import { Anchor, Text } from '@mantine/core';
import { type FC } from 'react';
import { Link } from 'react-router';
import { type Mode } from '~/shared/store/mode';
import { getOrderPath } from './lib';

export interface OrderIdLinkProps {
    direction: Mode;
    orderId?: string;
}

export const OrderIdLink: FC<OrderIdLinkProps> = ({ direction, orderId }) => {
    if (!orderId) {
        return (
            <Text
                truncate='end'
                maw={128}
            />
        );
    }

    return (
        <Anchor
            component={Link}
            to={getOrderPath(direction, orderId)}
            onClick={(event) => event.stopPropagation()}
        >
            <Text
                truncate='end'
                maw={128}
            >
                {orderId}
            </Text>
        </Anchor>
    );
};
